import './style.scss';

import { ID_AIRPORT_ICON_LAYER, ID_AIRPORT_RISK_LAYER } from 'utils/constants';

import {
  AirportFeatureCollectionIconLayer,
  AirportFeatureCollectionRiskLayer,
  createAirportGraphic,
  MakeAirportIconLayerLodRendererLikelihood,
  MakeAirportIconLayerLodRendererMagnitude,
  MapAirportModel2AirportPinVM,
} from './airport-lod-renderer';

const $ = (window as any).jQuery;

//=====================================================================================================================================
const LODBreakpoint = 4;
//=====================================================================================================================================

export default class AirportLayer {
  tooltipsEnabled = true;
  _esriPackages;
  airportIconLayer;
  airportRiskLayer;

  constructor(esriPackages) {
    const { FeatureLayer } = esriPackages;
    this._esriPackages = esriPackages;

    // Layer showing the icons where the airport is located
    this.airportIconLayer = new FeatureLayer(AirportFeatureCollectionIconLayer, {
      id: ID_AIRPORT_ICON_LAYER,
    });
    this.airportIconLayer.on('mouse-over', evt => {
      if (!this.tooltipsEnabled) return;
      let tooltip = $(evt.graphic.getNode());
      tooltip.popup({
        className: {
          popup: `ui popup tooltip top tooltip__airport`,
        },
        html: `
            <p class="tooltip__airport--name">${evt.graphic.attributes.AIRPORT_NAME}</p>
            <p class="tooltip__airport--city ${
              evt.graphic.attributes.LOCATION_NAME ? '' : 'hidden'
            }">${evt.graphic.attributes.LOCATION_NAME}</p>
            <hr class="tooltip__airport--divider"/>
            <p class="tooltip__airport--travellersTitle">Likelihood of case importation/month</p>
            <p class="tooltip__airport--travellers">${evt.graphic.attributes.LIKELIHOOD_TEXT}</p>
            <p class="tooltip__airport--probabilityTitle">Estimated case importations/month</p>
            <p class="tooltip__airport--probability">${
              evt.graphic.attributes.RISK_MAGNITUDE_TEXT
            }</p>
          `,
        on: 'click',
      });
      tooltip.trigger('click');

      tooltip.on('mouseleave', evt => {
        tooltip.popup('destroy');
      });
    });

    // Layer showing the risk to that airport using the size of the circle
    this.airportRiskLayer = new FeatureLayer(AirportFeatureCollectionRiskLayer, {
      id: ID_AIRPORT_RISK_LAYER,
      outFields: ['*'],
    });

    // Renderers are custom for these ones with LOD behaviour, so we set them separately:
    this.airportIconLayer.setRenderer(
      MakeAirportIconLayerLodRendererLikelihood(esriPackages, LODBreakpoint)
    );
    this.airportRiskLayer.setRenderer(
      MakeAirportIconLayerLodRendererMagnitude(esriPackages, LODBreakpoint)
    );
  }

  initializeOnMap(map) {
    if (!map.getLayer(ID_AIRPORT_RISK_LAYER)) {
      map.addLayer(this.airportRiskLayer);
    }
    if (!map.getLayer(ID_AIRPORT_ICON_LAYER)) {
      map.addLayer(this.airportIconLayer);
    }
  }

  addAirportPoints(airportList) {
    if (!airportList || !airportList.length) {
      this.clearAirportPoints();
      return;
    }

    const airportArray = MapAirportModel2AirportPinVM(
      airportList,
      'treatLowLikelihoodAsNegligibleRisk'
    );

    // Layers cannot share the same set of graphics
    const riskGraphics = airportArray.map(airport =>
      createAirportGraphic(this._esriPackages, airport)
    );
    const iconGraphics = airportArray.map(airport =>
      createAirportGraphic(this._esriPackages, airport)
    );

    this.clearAirportPoints();
    this.airportRiskLayer.applyEdits(riskGraphics);
    this.airportIconLayer.applyEdits(iconGraphics);
  }

  setLayerOpacity(opacity) {
    this.airportRiskLayer.setOpacity(opacity);
    this.airportRiskLayer.refresh();
    this.airportIconLayer.setOpacity(opacity);
    this.airportIconLayer.refresh();
  }

  setTooltipEnabled(flag) {
    this.tooltipsEnabled = flag;
  }

  clearAirportPoints() {
    this.airportRiskLayer.applyEdits(null, null, this.airportRiskLayer.graphics || []);
    this.airportIconLayer.applyEdits(null, null, this.airportIconLayer.graphics || []);
  }
}
